import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Autocomplete,
  TextField,
  Button,
  Switch,
} from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {getLocations} from '../utils';
import { updateSBSAccess } from "redux/actions/addEditWorker";

const WarehouseLogistics = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                            ? location.state.approveForManager : {};
  const user = useSelector((state) => state.user.auth.user);  
  const sbsData = useSelector(state => state.addEditWorker.workerRoles.SBS || {});
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
  const [disableSave, setDisableSave] = useState(true);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState(["Team Leader", "Supervisor", "Super User", "Warehouse Ops"])
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
      if(!districtOptions.length >0){
        getLocations().then(data => {
          const { sbsEnabledList=[] } = data;
          setDistrictOptions([...sbsEnabledList]);
        });
      }
  }, [])

  useEffect(() => {
    if(sbsData && Object.keys(sbsData).length>0){
      setFormValues(_.cloneDeep(sbsData));
    }
  }, [sbsData])

  useEffect(() => {
    console.log("IMTime Role", imtRole)
    if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
  },[imtRole])

  useEffect(() => {
    console.log("sbs formValues", formValues);
    if(formValues?.sbsDistricts?.length>0 && districtOptions.length>0){
      console.log("sbs buildings", districtOptions.length);
      const buildingOptions = [];
      districtOptions.forEach(record => {
        if(formValues?.sbsDistricts?.includes(record?.district)){
          const allBuildings = record?.buildings || {};
          console.log("sbs buildings", formValues?.sbsDistricts, allBuildings);
          Object.keys(allBuildings).forEach(building => {
            if(allBuildings[building].sbsEnabled === true){
              const option = {
                buildingID: building,
                districtID: record?.district || "",
                oracleID: allBuildings?.[building]?.['oracleId'] || ""
              }
              buildingOptions.push(option);
            } 
          })
        }
      })
      setBuildingOptions(buildingOptions);
    }else{
      setBuildingOptions([]);
    }
    validForm(formValues);
  } ,[formValues, districtOptions])

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.role){
        errors['role'] = "Field is required";
      }
      if(!formValues?.sbsBuildings?.length > 0){
        errors['sbsBuildings'] = "Field is required";
      }
      if(!formValues?.sbsDistricts?.length > 0){
        errors['sbsDistricts'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, sbsData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        throw new Error("Invalid data. Please check!")
      }
      
      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        role: formValues?.role || "",
        sbsDistricts: formValues?.sbsDistricts || [],
        sbsBuildings: formValues?.sbsBuildings || [],
        isActive: formValues?.isActive ? true : false,
        activityFamilyId: 'SBS'
      }
      console.log("SBS submit", formValues, data);
      const response = await dispatch(updateSBSAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "SBS Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "SBS Access update failed.",
          severity: 'error'
        })
      }


    }catch(error){
      console.log("SBS handleSumit error", error);
      setSnackControl({
        open: true,
        message: "SBS Access failed to submit.",
        severity: "error"
      })
    }
  }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
              <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)' }}>
            {loadingRoles ? <Skeleton /> : (
                <CardContent
                  style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
                >
                  <Typography variant="h5" color="#616161" marginBottom={3}>
                    Warehouse & Logistics
                  </Typography>
                  <hr id="customHr2" />
                  <>
                    <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                      <Grid
                        container
                        columnSpacing={3}
                        marginBottom={2}
                        alignItems="center"
                      >
                        <Grid item xs={2}  md={2} lg ={0.7}>
                          <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Switch 
                             inputProps={{ 'aria-label': 'Enable SBS Role switch' }}
                             checked={formValues?.isActive}
                             onChange={(e) => {
                               let checked = e.target.checked;
                               setFormValues({ ...formValues, isActive: checked });
                             }}
                             disabled={readOnly}
                          />
                        </Grid>
                      </Grid>
                      <Grid container columnSpacing={5} marginTop={3} spacing={3}>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Select District" 
                                required 
                                error= {formErrors?.sbsDistricts}
                                helperText= {formErrors?.sbsDistricts}
                              />
                            )}
                            id="sbsDistricts"
                            name="sbsDistricts"
                            size="small"
                            options={districtOptions || []}
                            multiple
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.district || option}
                            isOptionEqualToValue={(option, value) => option === value || option.district == value}
                            value={formValues?.sbsDistricts || []}
                            onChange={(e, v) => {
                              const districtIds = v ? v.map(record => record?.district || record) :[];
                              setFormValues(prevState => ({
                                ...prevState,
                                sbsDistricts: districtIds,
                                sbsBuildings:  prevState?.sbsBuildings ? 
                                prevState?.sbsBuildings.filter(record => districtIds.includes(record?.districtID)) : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} w
                                label="Select Building" 
                                required
                                error= {formErrors?.sbsBuildings}
                                helperText= {formErrors?.sbsBuildings}
                              />
                            )}
                            id="sbsBuildings"
                            name="sbsBuildings"
                            size="small"
                            disableCloseOnSelect
                            options={buildingOptions || []}
                            getOptionLabel={option => option.buildingID}
                            isOptionEqualToValue={(option, value) => value?.buildingID && value?.buildingID == option.buildingID}
                            multiple
                            value={formValues?.sbsBuildings || []}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({
                                ...prevState,
                                sbsBuildings: v ? v : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <Autocomplete
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Role"
                                required
                                error = {formErrors?.role}
                                helperText= {formErrors?.role}
                              />
                            )}
                            id="role"
                            name="role"
                            size="small"
                            options={roleOptions || []}
                            //readOnly 
                            value={formValues?.role || ""}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({...prevState, role: v? v : ''}));
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={11}
                      style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                    >
                      <div>
                        <Button
                          size="medium"
                          variant="outlined"
                          onClick={(e) => handleChange(e, 0)}
                          style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                        >
                          Cancel
                        </Button>
                        <Button
                          style={{ marginRight: 40, display: readOnly ? "none" : "" }}
                          size="medium"
                          variant="contained"
                          id="svBtn"
                          disabled={disableSave}
                          onClick={handleSubmit}
                        >
                          Save
                        </Button>
                      </div>
                    </Grid>
                  </>
                </CardContent>
            )}
              </Card>
        </form>
      </Box>
    </>
  );
};

export default WarehouseLogistics;
